import { useRef, useState } from 'react';
import { Card, Collapse } from 'antd';
import { useQuery } from '@apollo/client/react';

import BlockPhoneForm from './BlockPhoneForm';
import BlockedPhoneHistoryTable from './BlockedPhoneHistoryTable';
import EditBlockedPhoneModal from './EditBlockedPhoneModal';

import { BLOCKED_PHONE_NUMBER_HISTORY } from 'queries/blockPhone';

import useModalControls from 'hooks/useModalControls';

const BlockPhonePage = () => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const onEditCompleteRef = useRef(null);
  const editModal = useModalControls();

  const historyQuery = useQuery(BLOCKED_PHONE_NUMBER_HISTORY, {
    skip: !collapseOpen,
  });

  const handleEdit = (record, callback) => {
    setEditingRecord(record);
    onEditCompleteRef.current = callback || null;
    editModal.show();
  };

  return (
    <>
      <title>Block Phone Number | Admin</title>
      <Card title="Block Phone Number">
        <BlockPhoneForm onEdit={handleEdit} />
      </Card>

      <Collapse
        style={{ marginTop: 'var(--spacing-lg)' }}
        items={[
          {
            key: '1',
            label: 'Blocked Phone Number History',
            children: (
              <BlockedPhoneHistoryTable
                data={historyQuery.data?.blockedPhoneNumberHistory}
                loading={historyQuery.loading}
                onEdit={handleEdit}
              />
            ),
          },
        ]}
        onChange={(keys) => setCollapseOpen(keys.length > 0)}
      />

      <EditBlockedPhoneModal
        {...editModal}
        record={editingRecord}
        onEditComplete={onEditCompleteRef.current}
      />
    </>
  );
};

export default BlockPhonePage;
